module.exports = __webpack_public_path__ + "static/img/4.e140fc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn1/4.jpg
// module id = eKO5
// module chunks = 0